import { observable } from "@legendapp/state";
import { observer } from "@legendapp/state/react";
import { useConferenceSituationAndNps } from "_api/hooks/Client/conferences";
import { VStack } from "_ui/Box";
import { Modal } from "react-bootstrap";
import { Unless, When } from "react-if";
import styled from "styled-components";
import { $currentConferenceId, $selectedSituation } from "../state";

export const $npsOpen = observable(false);
export const $npsFinish = observable(false);

const NumberButton = styled.button`
    width: 40px;
    height: 40px;
    padding: 20px;
    border: none;
    border-radius: 50%;
    background-color: #f5f5f5;
    color: #333333;
    font-size: 20px;
    font-weight: bold;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.2s ease-in-out;

    &:hover {
        transform: scale(1.1);
    }

    &:active {
        background-color: #d0d0d0;
    }

    @media screen and (max-width: 991px) {
        //border-radius: 12px;
        //width: 85%;
        &:hover {
            transform: scale(1.05);
        }
    }
`
const Content = styled.div`
    height: 150px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: 991px) {
        height: unset;
        margin-left: 60px;
    }
`
const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
    justify-content: center;

    @media screen and (max-width: 991px) {
        //background: red;
        flex-direction: column;
        align-content: center;
        justify-content: center;
    }
`;

const NumberWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;

    @media screen and (max-width: 991px) {
        flex-direction: row;
    }
`;

const Number = ({ n, c, t, click }: { n: number, c: string, t: string, click: (n: number) => void }) => {
    return (
        <NumberWrapper onClick={() => click(n)}>
            <NumberButton style={{ background: '#' + c }}>{n}</NumberButton>
            <span>
                {t}
            </span>
        </NumberWrapper>
    );
}

const Numbers = () => {

    const { mutateAsync: setNps } = useConferenceSituationAndNps($currentConferenceId.$);
    const onClick = (n: number) => {
        $npsFinish.set(true);
        setNps({
            nps: n,
            situation: $selectedSituation.$
        });
    }

    return (
        <Wrapper>
            <Number n={1} c='FF3300' t='Péssima' click={onClick} />
            <Number n={2} c='FF6600' t='' click={onClick} />
            <Number n={3} c='FF9900' t='' click={onClick} />
            <Number n={4} c='FFCC00' t='' click={onClick} />
            <Number n={5} c='FFFF00' t='Neutra' click={onClick} />
            <Number n={6} c='CCFF33' t='' click={onClick} />
            <Number n={7} c='99FF66' t='' click={onClick} />
            <Number n={8} c='66FF99' t='' click={onClick} />
            <Number n={9} c='33FFCC' t='' click={onClick} />
            <Number n={10} c='00FF00' t='Excelente' click={onClick} />
        </Wrapper>
    );
}
let time: any | null = null;

export const Nps = observer(() => {
    if ($npsFinish.get()) {
        if (time) clearTimeout(time);

        time = setTimeout(() => {
            $npsOpen.set(false);
            setTimeout(() => $npsFinish.set(false), 200);
            time = null;
        }, 3000);
    }
    return (
        <Modal show={$npsOpen.get()} size="xl" fullscreen='md-down' centered>
            <Modal.Header>
                <Modal.Title className='text-center w-100'>
                    Como foi sua experiência?
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Unless condition={$npsFinish.get()}>
                    <Content>
                        <Numbers />
                    </Content>
                </Unless>
                <When condition={$npsFinish.get()}>
                    <VStack center alignCenter wFull style={{ height: '150px' }}>
                        <span className='fs-4 text-center'>
                            Obrigado por compartilhar sua experiência! 😀
                        </span>
                    </VStack>
                </When>
            </Modal.Body>
        </Modal>
    );
})
